module.exports = __webpack_public_path__ + "static/media/iso_logo.3654cedb.png";